export const adap_producto_carrito_lateral = ({producto, variacion, cantidad}) => {


    const obterNumMaximo = ( ) =>{

        let variaciones = producto.variaciones
        if (variaciones.length > 0){
            let index = variaciones.findIndex((e) => e.nombre === variacion.nombre)
            return parseInt(variaciones[index].cantidad)
        }else{
            return 0
        }

    }


    let obj = {
        nombre: producto.nombre,
        id: producto.id + variacion.nombre,
        cantidad: cantidad,
        img: producto.img,
        varianteNombre: variacion.nombre,
        valor: producto.valor,
        valorAntes: producto.valorAntes ? producto.valorAntes : 0,
        etiquetas: producto.etiquetas ? producto.etiquetas : [],
        idProducto: producto.id,
        numMaximo: obterNumMaximo()
    }

    return obj

}